import * as Actions from 'reducks/storeDeliveryBread/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const StoreDeliveryBreadReducer = (state = initialState.storeDeliveryBread, action: any) => {
  switch (action.type) {
    case Actions.CONFIRM_STORE_DELIVERY_BREAD:
      return {
        ...state,
        ...action.payload,
      }
    case Actions.FETCH_STORE_DELIVERY_BREAD:
      return {
        ...state,
        ...action.payload,
      }
    case Actions.INIT_STORE_DELIVERY_BREAD:
      return {
        ...initialState.storeDeliveryBread,
      }
    default:
      return state
  }
}
